import { useFormContext } from 'react-hook-form';
import classNames from 'classnames';

type RadioInputType = {
  id: string;
  value: string;
};

const RadioTile = ({
  input,
  fieldName,
}: {
  input: RadioInputType;
  fieldName: string;
}) => {
  const formContext = useFormContext();
  const formMethods = formContext.register(fieldName);

  const tileCheckedClasses =
    'has-[:checked]:bg-blank-yellow has-[:checked]:text-blank-black has-[:checked]:hover:bg-background-default-tertiary-hover';
  const tileHoverClasses =
    'hover:bg-background-default-tertiary-hover hover:text-blank-black';
  const animationClasses = 'transition-all duration-200 ease-in-out';

  return (
    <label
      key={input.id}
      htmlFor={input.id}
      className={`flex flex-col flex-1 gap-16 items-start text-lg p-16 border border-blank-yellow cursor-pointer group ${tileHoverClasses} ${tileCheckedClasses} ${animationClasses}`}
      role="radio"
      aria-checked={formContext.watch(fieldName) === input.value}
      aria-label={`radio ${input.value}`}
    >
      <div className="grid place-items-center mt-1">
        <input
          type="radio"
          id={input.id}
          value={input.value}
          {...formMethods}
          className={classNames(
            'peer appearance-none shrink-0',
            'col-start-1 row-start-1',
            'w-16 h-16 rounded-full text-lg',
            'border border-blank-yellow checked:border-blank-black group-hover:border-blank-black',
            animationClasses
          )}
        />
        <span
          className="
            pointer-events-none
            col-start-1 row-start-1
            w-8 h-8 rounded-full peer-checked:bg-blank-black"
        />
      </div>
      {input.value}
    </label>
  );
};

export { RadioTile };
export type { RadioInputType };
